import { defaultSettings } from './settings';
import { initFolders } from './folders';
import { initItems } from './items';
import { initHttp } from '../../utils/http';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { initFolder } from './folder';
import { CorrelationId } from '../../utils/CorrelationId';
export function Shutterstock(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = {
    ...defaultSettings,
    ...userSettings
  };
  const correlationId = new CorrelationId();
  const http = initHttp();
  const folders = initFolders(settings, http);
  const items = initItems(settings, http);
  const folder = initFolder(settings, http);
  this.name = 'shutterstock';
  this.correlationId = correlationId;
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.folder = addEvents(this, eventsList.FOLDER, folder);
}